import React from 'react';
import './image-gallery.css';

const ImageGallery = ({ column1, column2, column3, column4, openModal, showPhoto }) => {

	return (
		<div className='flex-container-photos'>
			<div className='column'>
				{column1 && column1.length > 0 ? (

					column1.map((photo) => {
						return (<img 
								  className='hover-shadow zoom-small' 
								  key={photo.id} 
								  src={`${photo.url}-small.jpg`}  // Default to small image
								  srcSet={`${photo.url}-small.jpg 300w, ${photo.url}-medium.jpg 600w, ${photo.url}-large.jpg 1200w`}
								  sizes="(max-width: 600px) 300px, (max-width: 1200px) 600px, 1200px"
								  alt={photo.title}
								  onClick={() => {
								    openModal();
								    showPhoto(photo.id);
								  }}
								/>)
					})) : (
					<p>There are currently no images in this category. </p>)
				}
			</div>
			<div className='column'>
				{
					column2.map((photo) => {
						return (<img 
								  className='hover-shadow zoom-small' 
								  key={photo.id} 
								  src={`${photo.url}-small.jpg`}  // Default to small image
								  srcSet={`${photo.url}-small.jpg 300w, ${photo.url}-medium.jpg 600w, ${photo.url}-large.jpg 1200w`}
								  sizes="(max-width: 600px) 300px, (max-width: 1200px) 600px, 1200px"
								  alt={photo.title}
								  onClick={() => {
								    openModal();
								    showPhoto(photo.id);
								  }}
								/>)
					})
				}
			</div>
			<div className='column'>
				{
					column3.map((photo) => {
						return (<img 
								  className='hover-shadow zoom-small' 
								  key={photo.id} 
								  src={`${photo.url}-small.jpg`}  // Default to small image
								  srcSet={`
								    ${photo.url}-small.jpg 300w, ${photo.url}-medium.jpg 600w, ${photo.url}-large.jpg 1200w`}
								  sizes="(max-width: 600px) 300px, (max-width: 1200px) 600px, 1200px"
								  alt={photo.title}
								  onClick={() => {
								    openModal();
								    showPhoto(photo.id);
								  }}
								/>)
					})
				}
			</div>
			<div className='column'>
				{
					column4.map((photo) => {
						return (<img 
								  className='hover-shadow zoom-small' 
								  key={photo.id} 
								  src={`${photo.url}-small.jpg`}  // Default to small image
								  srcSet={`${photo.url}-small.jpg 300w, ${photo.url}-medium.jpg 600w, ${photo.url}-large.jpg 1200w`}
								  sizes="(max-width: 600px) 300px, (max-width: 1200px) 600px, 1200px"
								  alt={photo.title}
								  onClick={() => {
								    openModal();
								    showPhoto(photo.id);
								  }}
								/>)
					})
				}
			</div>
		</div>
	)
}

export default ImageGallery;